class ActionHandler {
    constructor(actionName, stateReducer) {
        this.actionName = actionName;
        this.stateReducer = stateReducer;
    }
}

class ActionHandlerBuilder {
    constructor(actionName) {
        this.actionName = actionName;
    }

    using(stateReducer) {
        return new ActionHandler(this.actionName, stateReducer);
    }
}

class StateReducer {
    constructor(actionHandlers) {
        this.actionHandlers = actionHandlers;
    }

    reduce(state, action) {
        let newState;
        const actionHandler = this.actionHandlers.get(action.type);

        if (actionHandler) {
            newState = actionHandler(state, action);
        } else {
            newState = state;
        }
        return newState;
    }
}

export const reduceState = function (...actionHandlers) {
    let actionHandlerMap;
    if (actionHandlers) {
        actionHandlerMap = new Map(actionHandlers.map(actionHandler =>
            [actionHandler.actionName, actionHandler.stateReducer]
        ));
    } else {
        actionHandlerMap = new Map();
    }
    return new StateReducer(actionHandlerMap)
};

export const byHandlingAction = function (actionName) {
    return new ActionHandlerBuilder(actionName);
};


export const modifyState = function(oldState, newStateProperties) {
    const newState = {};
    Object.assign(newState, oldState);
    Object.assign(newState, newStateProperties);
    return newState;
};


/** WEBPACK FOOTER **
 ** ./src/shared_states/FluxEnhancements.js
 **/